import Tabs from "../tabs";
import { useMemo, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Stack
} from "@mui/material";
import DataTableWithSearch from "../../../../components/dataTableWithSearch/DataTableWithSearch";
import EditIcon from '@mui/icons-material/Edit';
import TodayIcon from "@mui/icons-material/Today";
import YesterdayIcon from "@mui/icons-material/History";
import DateRangeIcon from "@mui/icons-material/DateRange";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";


const ASSIGN_SLOT_DATA = [
  {
    id: 10952,
    employee_id: 550,
    employee_name: "Ramesh",
    emp_mobile: "919121218365",
    designation: "General Physician",
    branch_department_id: 1,
    branch_department_name: "KONDAPUR (Marketing)",
    "1769064700": [
      { appointment_slot_id: 2, slot_name: "1 pm to 3 pm" },
    ],
  },
  {
    id: 10953,
    employee_id: 551,
    employee_name: "Suresh",
    emp_mobile: "919876543210",
    designation: "Cardiologist",
    branch_department_id: 2,
    branch_department_name: "KPHB (Marketing)",
    "1769064700": [
      { appointment_slot_id: 3, slot_name: "3 pm to 5 pm" },
      { appointment_slot_id: 4, slot_name: "5 pm to 7 pm" },
    ],
  },
  {
    id: 10954,
    employee_id: 552,
    employee_name: "Mahesh",
    emp_mobile: "919998887766",
    designation: "Orthopedic Surgeon",
    branch_department_id: 3,
    branch_department_name: "KONDAPUR (Academic)",
    "1769064700": [
      { appointment_slot_id: 1, slot_name: "10 am to 12 pm" },
    ],
  },
];


const CARD_DATA = [
  { id: 1, label: "Today Slots", count: 4, icon: TodayIcon, color: "#1E88E5" },
  { id: 2, label: "YesterDay", count: 3, icon: YesterdayIcon, color: "#43A047" },
  { id: 3, label: "Last 7 Days", count: 3, icon: DateRangeIcon, color: "#FB8C00" },
  { id: 4, label: "Last 30 Days", count: 4, icon: CalendarMonthIcon, color: "#7E57C2" },
  { id: 5, label: "OverAll", count: 2, icon: AllInclusiveIcon, color: "#546E7A" },
];


function AssignSlotsList() {
  const [state, setState] = useState({
    activeCard: 1,
  });
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const { activeCard,  } = state;

  const handleChangeCard = (id) => {
    setState(prev => ({ ...prev, activeCard: id }));
  };


  const columns = useMemo(() => [
    { header: "SNO", accessorKey: "sno", enableGlobalFilter: true },
    {
      accessorKey: "employee_name",
      header: "Name",
      Cell: ({ row }) => (
        <span
          style={{ display: "inline-block" }}
        >
          <Box
            component="span"
            sx={{
              cursor: "pointer",
              color: `var(--link)`,
              textDecoration: "none",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
          >
            {row.original.employee_name}
          </Box>
        </span>
      )
    },
    { header: "Mobile", accessorKey: "emp_mobile" },
    { header: "Designation", accessorKey: "designation" },
    { header: "Branch & Departments", accessorKey: "branch_department_name" },
    {
      header: "Action",
      accessorKey: "actions",
      Cell: ({ row }) => {
        return <EditIcon />
      }
    }
  ], []);
  return (
    <div>
      <Tabs />

      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={1.5}
        mt={2}
      >
        {CARD_DATA.map(({ id, label, count, icon: Icon, color }) => {
          const isActive = activeCard === id;

          return (
            <Card
              key={id}
              onClick={() => handleChangeCard(id)}
              sx={{
                flex: 1,
                height: 85,
                px: 1.5,
                cursor: "pointer",
                borderRadius: 2,
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                transition: "0.25s ease",
                border: `1.5px solid ${isActive ? color : "transparent"}`,
                boxShadow: isActive
                  ? `0 6px 14px ${color}55`
                  : "0 2px 8px rgba(0,0,0,0.08)",
                "&:hover": {
                  transform: "translateY(-3px)",
                  boxShadow: `0 10px 18px ${color}66`,
                },
              }}
            >
              {/* Gradient Top Strip */}
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  height: 4,
                  width: "100%",
                  background: `linear-gradient(90deg, ${color}, transparent)`,
                  borderTopLeftRadius: 8,
                  borderTopRightRadius: 8,
                }}
              />

              {/* Left Content */}
              <Stack spacing={0.3}>
                <Typography
                  variant="body"
                  color={isActive ? `${color}` : "var(--dark-bg)"}
                  lineHeight={2}
                >
                  {label}
                </Typography>

                <Typography variant="h5" fontWeight={700}>
                  {count}
                </Typography>
              </Stack>

              {/* Icon */}
              <Box
                sx={{
                  backgroundColor: color,
                  color: "#fff",
                  borderRadius: "50%",
                  p: 1.5,
                  display: "flex",
                  transition: "all 0.35s ease",
                }}
              >
                <Icon fontSize="small" />
              </Box>
            </Card>
          );
        })}
      </Stack>


      <Box mt={2}>
        <Card>
          <CardContent>
            <DataTableWithSearch
              columns={columns}
              data={ASSIGN_SLOT_DATA}
              status={false}
            />
          </CardContent>
        </Card>
      </Box>
    </div>
  );
}
export default AssignSlotsList;